import React from "react";

/* DATA IMPORT */
import data from "./catalogue_data/Twiceme.json";

/* COMPONENTS */
import { CatalogueHero } from "../sections/Hero";
import { ContactMe } from "../sections/ContactMe";
import { ProjectDescription } from "../sections/ProjectDescription";
import { Logo, Colors, Mockups, Typography } from "../sections/Presentations";

const Twiceme = () => {
  const { page } = data;
  const key = "twiceme";

  return (
    <section id={key}>
      <CatalogueHero title={page.title} desc={page.desc} roles={page.roles} />
      <ProjectDescription
        desc={page.overview}
        duration={page.duration}
        roles={page.roles}
      />
      {/* <Insights insight_arr={page.insights} /> */}
      <Logo type={key} />
      <Typography type={key} />
      <Colors type={key} />
      <Mockups type={key} />
      <ContactMe />
    </section>
  );
};

export default Twiceme;
